/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-03 11:25:35
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-04 11:43:34
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/Tabs/index.tsx
 */
import React from 'react';
import { TabsGroup } from 'src/components/Antd';
import { EnumReducers } from 'src/pages/SalesChannelCategory/slice/constants';
import css from './css.module.less';

import { getI18nFromGeneral } from 'src/tools/tools';
import Content from '../ContentCategory';
import Legal from '../LegalCategory';

export const PageCategoryTabContext = React.createContext(null);

const types = [EnumReducers.legal, EnumReducers.content];
const Tabs = (props) => {
  const { panes } = props;

  const [activeKey, setActiveKey] = React.useState(EnumReducers.legal);
  const handleActiveKeyOnChange = (e) => {
    setActiveKey(e);
  };

  return (
    <PageCategoryTabContext.Provider
      value={{
        activeKey: activeKey,
      }}>
      <TabsGroup
        onChange={handleActiveKeyOnChange}
        tabsWrapperClassName={css.tabsWrapper}
        // FixedBelowTabsComponent={
        //   <Element>
        //     <div>Search</div>
        //   </Element>
        // }
        activeKey={activeKey}
        tabsProps={{ size: 'large' }}
        panes={panes}
      />
    </PageCategoryTabContext.Provider>
  );
};
const titleDic = {
  [EnumReducers.legal]: getI18nFromGeneral('general.sider.legalPage'),
  [EnumReducers.content]: getI18nFromGeneral('general.sider.contentPage'),
};
const _Tabs = (props) => {
  const { userPermissions } = props;
  const CompDic = React.useMemo(() => {
    return {
      [EnumReducers.legal]: <Legal userPermissions={userPermissions} />,
      [EnumReducers.content]: <Content userPermissions={userPermissions} />,
    };
  }, []);
  const panes = types.map((i) => {
    return {
      title: titleDic[i],
      key: i,
      id: i,
      content: CompDic[i],
    };
  });
  return <Tabs panes={panes} />;
};
export default _Tabs;
